/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rm_Join_TitleInputs */

const en_rm_join_title = /** @type {(inputs: Rm_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the room`)
};

const id_rm_join_title = /** @type {(inputs: Rm_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung ke ruang`)
};

/**
* | output |
* | --- |
* | "Join the room" |
*
* @param {Rm_Join_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rm_join_title = /** @type {((inputs?: Rm_Join_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rm_Join_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rm_join_title(inputs)
	return en_rm_join_title(inputs)
});